import { FC } from 'react'

import { useAnalyticsContext } from 'analytics/hooks'
import InternaFilesByTypesModal, { InternalDriverFilesByTypesProps } from './InternaFilesByTypesModal'

export const FilesByTypesModal: FC<InternalDriverFilesByTypesProps> = ({ files, onDelete, refetch, ...otherProps }) => {
  const { track } = useAnalyticsContext()

  const handleDelete = async (documentId: string) => {
    onDelete?.(documentId)

    track('delete|document', {
      id: documentId,
      value: {
        to: files.find((f) => f.id.toString() === documentId.toString()),
      },
    })
  }

  return <InternaFilesByTypesModal refetch={refetch} onDelete={handleDelete} files={files} {...otherProps} />
}
